import type { TeamRole } from '../types/auth';

export const PERMISSIONS = {
  jobsManage: 'jobs.manage',
  applicationsManage: 'applications.manage',
  interviewsManage: 'interviews.manage',
  messagesManage: 'messages.manage',
  offersManage: 'offers.manage',
  teamManage: 'team.manage',
  assignedInterviewsView: 'interviews.assigned.view',
  feedbackSubmit: 'feedback.submit',
} as const;

export const ADMIN_WORKSPACE_PERMISSIONS = [
  PERMISSIONS.jobsManage,
  PERMISSIONS.applicationsManage,
  PERMISSIONS.interviewsManage,
  PERMISSIONS.messagesManage,
  PERMISSIONS.offersManage,
  PERMISSIONS.teamManage,
];

export function hasPermission(granted: string[], required: string): boolean {
  return granted.includes('*') || granted.includes(required);
}

export function hasAnyPermission(granted: string[], required: string[]): boolean {
  return required.some((permission) => hasPermission(granted, permission));
}

export function defaultLanding(role: TeamRole | null, permissions: string[]): string {
  if (role === 'panelist' && hasPermission(permissions, PERMISSIONS.assignedInterviewsView)) {
    return '/panel';
  }
  if (hasAnyPermission(permissions, ADMIN_WORKSPACE_PERMISSIONS)) {
    return '/admin';
  }
  return '/dashboard';
}
